import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=0703d052&scoped=true&"
import script from "./certificate.vue?vue&type=script&lang=js&"
export * from "./certificate.vue?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&id=0703d052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0703d052",
  null
  
)

export default component.exports